<section class="sites" [attr.aria-labelledby]="titleId">
  <div class="sites__head">
    <h3 class="sites__title" [id]="titleId">
      <!-- Expanded, the title folds the list back to the top few -->
      @if (showAll()) {
        <button type="button" class="sites__fold" aria-expanded="true" title="Show fewer" (click)="showAll.set(false)">
          Top sites
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 10l4-4 4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      } @else {
        Top sites
      }
    </h3>
    @if (selected().size) {
      <button type="button" class="sites__link" (click)="clear.emit()">Clear</button>
    }
  </div>
  <ul class="sites__list">
    @for (site of sites(); track site.host) {
      @let on = selected().has(site.host);
      <li>
        <button type="button" class="site" [class.site--active]="on" [attr.aria-pressed]="on" (click)="toggle.emit(site.host)">
          @if (site.favicon) {
            <img class="site__favicon" [src]="site.favicon" alt="" width="14" height="14" loading="lazy" (error)="hideBrokenImage($event)" />
          }
          <span class="site__host">{{ site.host }}</span>
          <span class="site__count">{{ site.count }}</span>
        </button>
      </li>
    }
    @if (!phone && (total() > sites().length || showAll())) {
      <li>
        <button type="button" class="sites__link sites__more" (click)="showAll.set(!showAll())">
          {{ showAll() ? 'Show fewer' : 'Show all ' + total() }}
        </button>
      </li>
    }
  </ul>
  <p class="sites__hint">Pick one or more sites to filter the results.</p>
</section>
